import { ajaxRequest } from "../Utils/Ajax/ajax"
import { successToast } from "../Utils/utils"


export function loadUserReset(){

    
    $("#submit-btn").on("click", function(e){
        e.preventDefault()
        const data = $("#reset-user-form").serializeArray()

        const userId = $("#user-id").val()
        const key = $("#key").val()
        const url = '/reset-user/' + userId.toString() + '/' + key

        const success = function(data){
            $("#submit-btn").remove()
            $("#reset-success").fadeIn('fast')
            $("#user-name-after").html(data.username)
            $("#reset-password").remove()
            $(".progress-bar").css("width", "100%");
            successToast("Deine LogIn-Daten wurden aktualisiert!")
        }

        ajaxRequest(url, success, data, $(this))

    })

}